;(function() {
  'use strict'

  /* Community Dialog
     *
     * Attempts to convert anyone into a glow user by asking them to join
     * a community. The dialog adapts to the type of user which affects
     * which `pathway` they need to take in order to reach the end
     * goal... joining the community
     *
     * Unknown: login or create profile + join
     * Email-User: complete profile + join
     * Logged-In: join community if not already
     *
     */

  Controller.$inject = ["$scope", "$q", "$log", "$timeout", "glAnalytics", "communityService", "userService", "glDialog"];
  angular
    .module('core.communityDialog')
    .controller('CommunityDialog', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $q,
    $log,
    $timeout,
    glAnalytics,
    communityService,
    userService,
    glDialog
  ) {
    var log = $log.create('CommunityDialog')
    $scope.formData = $scope.formData || {}
    $scope.usernameChecker = userService.getUsernameChecker()
    $scope.emailChecker = userService.getEmailChecker()
    $scope.closeDialog = closeDialog
    $scope.closeButton = closeButton
    $scope.isValidForm = isValidForm
    $scope.join = join
    $scope.login = login
    $scope.pathways = {
      UNKNOWN: 'unknown',
      EMAILUSER: 'email-user',
      LOGGEDIN: 'logged-in',
    }
    init()

    /* @name init
         *
         * figure out and set up which pathway we need to take. if the
         * user has already joined the community, close the dialog and continue.
         */
    function init() {
      // no element cancels dialog
      if (!$scope.element) {
        log.info('no element, skipping')
        track('no-element-supplied')
        return closeDialog(false)
      }

      // figure out pathway
      $scope.pathway = getPathway()
      log.info('pathway is: ' + $scope.pathway)

      // get latest list of communities
      $scope.state = 'getting communities'

      $scope.community = communityService.get($scope.element.id)
      if ($scope.community.isJoined()) {
        log.info('user already joined this community, skipping')
        track('already-joined')
        return closeDialog(true)
      }

      // begin pathway
      $scope.state = 'pathway'
    }

    /* @name closeButton
         *
         * called when the user clicks the X at the top right
         */
    function closeButton() {
      track('closed-dialog')
      closeDialog(false)
    }

    /* @name closeDialog
         *
         * closes the dialog.
         *
         * @param {Boolean} hasJoined whether the user ended up joining
         */
    function closeDialog(hasJoined) {
      if (hasJoined) {
        log.info('closing')
        $scope.dialog.close()
      } else {
        log.info('cancelling')
        $scope.dialog.cancel()
      }
      if ($scope.onClose) {
        log.info('calling onClose()')
        $scope.onClose()
      }
    }

    /* @name isValidForm
         *
         * @param {Object} form the form element directive's scope
         * @return {Boolean} whether the form is valid
         */
    function isValidForm(form) {
      $scope.form = form || $scope.form
      switch ($scope.pathway) {
        case $scope.pathways.LOGGEDIN:
          return true
        case $scope.pathways.EMAILUSER:
          return (
            $scope.form.$valid && $scope.usernameChecker.state === 'available'
          )
        case $scope.pathways.UNKNOWN:
          return (
            $scope.form.$valid &&
            $scope.usernameChecker.state === 'available' &&
            $scope.emailChecker.state === 'available'
          )
      }
    }

    /* @name join
         *
         * creates the user if needed and then joins the community
         *
         */
    function join() {
      if (!isValidForm()) {
        log.info('tried to join but form not valid')
        return
      }

      $scope.isJoining = true
      if ($scope.pathway === $scope.pathways.LOGGEDIN) {
        log.info('user logged in, joining...')
        $scope.community.join().then(done, error)
      } else {
        createUserAndJoin().then(done, error)
      }

      function createUserAndJoin() {
        return userService.signup($scope.formData).then(function() {
          track('joined')
          return $scope.community.join()
        })
      }

      function done() {
        log.info('mission successful')
        closeDialog(true)
      }

      function error() {
        track('join-error')
        log.info('join errored')
        $scope.error = 'Check your details and try again'
        $scope.isJoining = false
      }
    }

    /* @name login
         *
         * caches the state of this dialog, closes it, and brings up the
         * login dialog. upon that dialog closing/cancelling this
         * dialog is resumed using the cached data
         *
         */
    function login() {
      // close this dialog
      track('logging-in')
      log.info('closing dialog to display login')
      $scope.dialog.close()

      // display the login dialog
      glDialog
        .show({
          templateUrl: 'auth-dialog.template.html',
          controller: 'AuthDialogController',
          locals: {
            state: 'login',
          },
        })
        .finally(function() {
          // resume this dialog where we left off
          track('did-login')
          log.info('resuming where we left off')
          glDialog.show({
            templateUrl: 'community-dialog.template.html',
            controller: 'CommunityDialog',
            escapeToClose: false,
            locals: {
              emailUser: $scope.emailUser, // needed in case user didn't login
              element: $scope.element,
              onClose: $scope.onClose,
            },
          })
        })
    }

    /* @name getPathway
         *
         * discovers what pathway the user needs to take to join the community
         *
         * @return {String} the pathway constant
         */
    function getPathway() {
      if (userService.loggedIn()) {
        return $scope.pathways.LOGGEDIN
      } else if ($scope.emailUser) {
        $scope.formData.email = $scope.emailUser.email
        return $scope.pathways.EMAILUSER
      }
      return $scope.pathways.UNKNOWN
    }

    /* @name track
         *
         * a shorthand method to glAnalytics. automatically applies the
         * category and label so that we don't have to repeat ourselves
         *
         * @param {String} action the action that was taken
         */
    function track(action) {
      log.debug('track -> action=' + action + ' pathway=' + $scope.pathway)
      glAnalytics.track('CommunityDialog', action, $scope.pathway)
    }
  }
})()
